<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-12 15:36:17
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-09-23 15:55:02
 * @FilePath: /jy-dashboard-web/src/components/productionManagement/map-dtfb2.vue
 * @Description: 地图-分布
-->
<template>
  <div class="dtfb2" id="map"></div>
  <div
    id="popup"
    class="ol-popup2"
    :class="[feature.operation === 1 ? 'wh1' : 'wh2']"
    v-show="showPopup"
  >
    <span class="title">{{ feature.name }}</span>
    <section
      class="data"
      v-loading="loading.sbxx"
      v-if="feature.operation === 1"
    >
      <section class="row" v-for="(item, index) in sbxx" :key="index">
        <span class="name">{{ item.device_name + ":" }}</span>
        <span class="value">{{ item.value + item.unit }}</span>
      </section>
    </section>
    <section class="video" v-else>
      <iframe :src="feature.remarks" frameborder="0"></iframe>
    </section>
  </div>
</template>

<script>
import 'ol/ol.css'
import Map from 'ol/Map'
import View from 'ol/View'
import Overlay from 'ol/Overlay'
import TileLayer from 'ol/layer/Tile'
import XYZSource from 'ol/source/XYZ'
import WMTSSource, { optionsFromCapabilities } from 'ol/source/WMTS'
import WMTSCapabilities from 'ol/format/WMTSCapabilities'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import GeoJSON from 'ol/format/GeoJSON'
import Point from 'ol/geom/Point'
import Feature from 'ol/Feature'
import { Style, Icon, Stroke } from 'ol/style'
import { fromLonLat } from 'ol/proj'
// import dk from '@/assets/dk.json'
import { mapActions, mapState } from 'vuex'
export default {
  data () {
    return {
      map: '',
      overlay: '',
      view: '',
      showPopup: false,
      feature: {},
      index: 0
    }
  },
  watch: {
    dtfb () {
      this.initMap()
    }
  },
  computed: {
    ...mapState('production-management', ['dtfb', 'sbxx', 'loading'])
  },
  methods: {
    ...mapActions('production-management', ['getDTFB', 'getSBXX']),
    async initMap () {
      document.getElementById('map').innerHTML = ''
      const res = await fetch('http://120.55.82.159:9005/geoserver/gwc/service/wmts?REQUEST=GetCapabilities')
      const resText = await res.text()
      const capabilities = (new WMTSCapabilities()).read(resText)
      const options = optionsFromCapabilities(capabilities, {
        layer: 'jiuyu:jiuyuhebin2',
        matrixSet: 'EPSG:4326'
      })
      this.overlay = new Overlay({
        element: document.getElementById('popup'),
        autoPan: {
          animation: {
            duration: 250
          }
        },
        insertFirst: true
      })

      const iconFeatures = []
      let iconFeature = ''
      let scale = 0
      this.dtfb.reverse().map((item) => {
        iconFeature = new Feature({
          geometry: new Point(fromLonLat([Number(item.longitude), Number(item.latitude)])),
          ...item
        })
        if (item.type_name === '气象站' || item.type_name === '摄像头') {
          scale = 1
        } else {
          scale = 0.7
        }
        iconFeature.setStyle(new Style({
          image: new Icon({
            imgSize: [36, 50],
            scale: scale,
            src: `image/production-management/map/${item.type_name}@2x.png`
          })
        }))
        iconFeatures.push(iconFeature)
        return item
      })
      this.view = new View({
        center: fromLonLat([119.8875, 30.4025]),
        zoom: 17,
        minZoom: 15,
        maxZoom: 21,
        rotation: 0
      })

      this.map = new Map({
        target: 'map',
        layers: [
          new TileLayer({
            source: new XYZSource({
              url: '//t0.tianditu.com/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=f7c02e7265b55e36095db404f730a7f6',
              wrapX: false
            })
          }),
          new TileLayer({
            opacity: 1,
            source: new WMTSSource(options)
          }),
          new VectorLayer({
            source: new VectorSource({
              url: 'dk.geojson',
              format: new GeoJSON()
            }),
            style: function (feature) {
              return new Style({
                stroke: new Stroke({
                  color: '#00f1ff',
                  lineDash: [3, 9, 15],
                  width: 4
                })
              })
            }
          }),
          new VectorLayer({
            source: new VectorSource({
              features: iconFeatures
            })
          })
        ],
        view: this.view,
        overlays: [this.overlay]
      })

      this.map.on('singleclick', (event) => {
        this.showPopup = false
        const feature = this.map.forEachFeatureAtPixel(event.pixel, (feature, layer) => {
          return feature
        })
        if (feature && feature.values_.operation !== 0) {
          this.feature = feature.values_
          this.overlay.setPosition(event.coordinate)
          this.showPopup = true
          if (feature.values_.operation === 1) {
            this.getSBXX(feature.values_.terminal_id)
          }
        }
      })
    }
  },
  created () {
    this.getDTFB()
  }
}
</script>

<style lang="scss">
.ol-popup2 {
  position: absolute;
  bottom: 15px;
  left: -153px;
  background-size: 100% 100%;
  background-image: url("/public/image/production-management/bg/地图弹窗@2x.png");
  // z-index: 1000;
  .title {
    font-size: 20px;
    line-height: 22px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #ffffff;
    position: absolute;
    top: 26px;
    left: 22px;
    width: 168px;
  }
  .data {
    position: absolute;
    top: 73px;
    left: 22px;
    height: 196px;
    width: calc(100% - 44px);
    .row {
      height: 28px;
      line-height: 28px;
      .name {
        display: inline-block;
        vertical-align: top;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
        opacity: 0.54;
        margin-right: 20px;
      }
      .value {
        display: inline-block;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
  .video {
    position: absolute;
    top: 73px;
    left: 22px;
    height: 96px;
    width: calc(100% - 44px);
  }
}
.wh1 {
  width: 306px;
  height: 309px;
  left: -153px;
}
.wh2 {
  width: 346px;
  height: 261px;
  left: -173px;
}
</style>
